import React from "react";

function Education() {
  const educationDetails = [
    {
      degree: "Postgraduate Degree in Web Development",
      institution: "Conestoga College, Canada",
      year: "2024",
    },
    {
      degree: "Bachelor's in Computer Engineering",
      institution: "University of Mumbai, India",
      year: "2019",
    },
  ];
  const Certification =[
    {
      title:"Introduction to Generative AI",
      organisation:"Google",
      date:"Dec 2025"
    },
     {
      title:"Developing CI/CD Solutions with Azure DevOps",
      organisation:"Linkedin",
      date:"Feb 2025"

    },
    {
      title:"Microsoft Certified: Azure AI Fundamentals",
      organisation:"Microsoft",
      date:"Nov 2024"

    },
    {
      title:"AWS FOUNDATION:GETTING STARTED WITH THE AWS CLOUD ESSENTIALS",
      organisation:"Amazon",
      date:"Sept 2024"
    }
   
  ]

  

  return (
    
    <>
    <h1 className="text-3xl md:text-4xl text-center mb-8">
          <span className="section-heading text-3xl md:text-4xl">EDUCATION</span>
            </h1>


             <div className="grid place-items-center px-2">
              <div className="w-full max-w-5xl space-y-5 text-slate-200">
                {educationDetails.map((edu,index)=>(
                  <div
                   key={index}
                   className="rounded-2xl p-6 md:p-7 border border-violet-400/15 bg-white/[0.03] backdrop-blur-sm shadow-lg shadow-indigo-950/30 transition-all duration-300 hover:border-sky-400/20">
                    <h3 className="text-lg md:text-xl font-semibold text-slate-100 tracking-tight">{edu.degree}</h3>
                    <p className="mt-2 text-sky-200/85">{edu.institution}</p>
                    <p className="mt-1 text-sm text-slate-400">{edu.year}</p>
                  </div>
                ))}
              </div>
            </div>

            <h2 className="text-2xl md:text-3xl text-center mt-14 mb-6">
              <span className="section-heading text-2xl md:text-3xl">CERTIFICATIONS</span>
            </h2>
            <div className="grid place-items-center px-2 pb-4">
              <ul className="w-full max-w-5xl space-y-4">
                {Certification.map((c, i) => (
                  <li
                    key={i}
                    className="rounded-xl px-5 py-4 border border-violet-400/12 bg-white/[0.025] flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 text-left"
                  >
                    <span className="text-slate-100 font-medium">{c.title}</span>
                    <span className="text-sm text-slate-400">
                      {c.organisation} · <span className="text-sky-200/70">{c.date}</span>
                    </span>
                  </li>
                ))}
              </ul>
            </div>
    </>
  );
}

export default Education;
